// extracted by mini-css-extract-plugin
module.exports = {"container":"_3-l0pCfhUaBFNDRHarNJ37","restaurantsList":"_3h7vsybXyY5y_R3Klz1iwu","item":"_1uB_Ahqd4IRadORVxzoGN9","dot":"_1S9Edpqnfprkwe_zijIVnW","input":"WvIUZhmkEAVONVXftVnvV"};